export default "__VITE_PUBLIC_ASSET__d5f5cea6__"